import React from "react";
import { connect } from "react-redux"
import swal from "sweetalert2";

class Increment extends React.Component {
  componentDidUpdate() {
    this.props.setCostPhoto();
  }
  constructor(props) {
    super(props);
    this.state = {
      template: [],
      acceptedFileType: [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif"
      ],
    };
    this.onChange = this.onChange.bind(this);
  }
  onChange(file) {
    var getFiles = file.target.files;
    if (getFiles.length > 0) {
      var getFile = getFiles[0];
      if (this.state.acceptedFileType.indexOf(getFile.type) === -1) {
        swal({
          title: "HATA",
          text: "Desteklenmeyen dosya tipi seçtiniz.",
          type: "error",
          showConfirmButton: false
        }).catch(swal.noop);
      }
    }
  }
  plusClick(e) {
    var getIncrementTemplate = this.state.template;
    let constNumber = this.props.costNumber ;

    getIncrementTemplate.push(
      <div className="costPhotoDiv" data-costPhotoField={constNumber} style={{ marginBottom: "10px" }} id="costPhoto">
        <input type="file" accept="image/png,image/jpeg,image/jpg,image/gif" style={{ width: "100%" }} id="costPhotoInput" onChange={this.onChange} className="form-control border-input costPhoto" />
        <strong className="deleteCostPhoto" onClick={() => { document.querySelector(".costPhotoDiv[data-costPhotoField='" + constNumber + "']").remove(); this.props.setCostPhoto();
          this.setState({
            template: []
          });
        }}>
          {this.props.t('removePhoto')}
            </strong><br />
      </div>);
    this.setState({
      template: getIncrementTemplate
    });
  }
  render() {
    return (
      <div className="content" style={{ float: "left" }}>
       {this.props.required ?
        <span className="star">*</span>
        : null
       }
        <label>
          <a href="#" onClick={(e) => {
            e.preventDefault();
            //Todo: çoklu fotoğraf eklentisi çalışmıyordu ancak ekleniyormuş gibi çalışıyordu
            // o nedenle çoklu foto eklemeyi engelledik, iyileştirmeyle tekrar açacağız
            if( this.state.template.length < 1) {
              this.plusClick()
            }
          }
          } className="increment-photo">
            (+)</a>
           {this.props.t('addPhoto')}</label>
        {this.state.template.map((x, i) => {
          return <div key={i}>{x}</div>;
        })}
        <br />
      </div>);
  }
}

const mapStateToProps = (state) => {
  return {
    costId: state.cost.costId
  }
};
const dispatchToProps = (dispatch) => {
  return {}
};

export default connect(mapStateToProps, dispatchToProps)(Increment);
